// extracted by mini-css-extract-plugin
export default {"Icon":"TemplateServiceChartRow_Icon__XNCsG","VendorContainer":"TemplateServiceChartRow_VendorContainer__NHMXI"};